import { render, staticRenderFns } from "./AccountManagerOrganizationsWidget.vue?vue&type=template&id=3f578daa"
import script from "./AccountManagerOrganizationsWidget.vue?vue&type=script&lang=js"
export * from "./AccountManagerOrganizationsWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports